import { Document } from '@models/matter';

export class ExternalDocumentUpdate {
	static readonly type = '[ html editor ] externally updated';
	constructor(
		public documentId: string,
		public documentHtml: string,
		public document?: Document,
	) {}
}
